import { IMenuItemScope } from "./menu";


export function QpMenuChildDirective($timeout: angular.ITimeoutService, $injector: angular.auto.IInjectorService): angular.IDirective {
    return {
        restrict: "AE",
        scope: {
            qpMenuChild: "<",
            pid: "<",
            isShow:"=?"
        },
        bindToController: true,
        controllerAs: "ctrl",
        require: ["^?qpMenu", "^?qpMenuChild"],
        controller: ["$scope", function ($scope) {
            let vm = this;
            vm.menuList = [];
            vm.parentMenu;
            vm.parentMenuId;

            /**
             * @description 添加菜单项
             * @param item 
             */
            vm.addItem = function (menuItem: IMenuItemScope) {
                if (angular.isUndefined(vm.menuList)) {
                    vm.menuList = [];
                }
                vm.menuList.push(menuItem);
                if (vm.parentMenu && vm.parentMenuId) {
                    vm.parentMenu.updateChildMenu(vm.parentMenuId, vm);
                }
            }
        }],
        link: (scope: any, elem: JQLite, attr, ctrls: Array<angular.IController>) => {
            const parentMenuCtrl = ctrls[0];
            const selfCtrl = ctrls[1];
            // 子导航默认隐藏
            elem.addClass("ng-hide");

            selfCtrl.parentMenu = parentMenuCtrl;

            selfCtrl.parentMenuId = selfCtrl.qpMenuChild || selfCtrl.pid;
            if(angular.isUndefined(selfCtrl.isShow)){
                selfCtrl.isShow = false;
            }

            if (selfCtrl.menuList && selfCtrl.menuList.length > 0) {
                parentMenuCtrl.updateChildMenu(selfCtrl.parentMenuId, selfCtrl);
            }

            scope.$watch("ctrl.isShow", (newVal, oldVal) => {
                if (newVal == oldVal) {
                    return;
                }
                if (newVal) {
                    elem.removeClass("ng-hide");
                } else {
                    elem.addClass("ng-hide");
                }
            })

        }
    }
}

QpMenuChildDirective.$inject = ["$timeout", "$injector"];